var React = require('react');

function IconReportSales (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18,0A18,18,0,1,0,36,18,18,18,0,0,0,18,0Zm0,32.57A14.57,14.57,0,1,1,32.57,18,14.58,14.58,0,0,1,18,32.57ZM29,13.9l-7.3-1.44L18.12,6l-3.86,6.5L7,13.9l5,5.66,0,0v0l-.74,7.51L18,24l6.77,3.1L24,19.59l0,0Z"}));
}

IconReportSales.defaultProps = {"viewBox":"0 0 36 36"};

module.exports = IconReportSales;

IconReportSales.default = IconReportSales;
